// extracted by mini-css-extract-plugin
export default {"text":"ExpandButton_text__Q4ryq","button":"ExpandButton_button__UeZEr"};